import { useTheme } from "@mui/material";
import React from "react";
import ArrowInsertSvg from "../../../components/svgComponents/ArrowInsertSvg";
import TradesTable from "../../../components/trade/tradeTable";
import SectionHeader from "../SectionHeader/SectionHeader";

const LatestTrades = ({
  activeTab,
  connectedAccount,
  selectedToken,
  selectedToken2,
  swapConfirmModal,
}) => {
  const theme = useTheme();
  const handleClick = () => {
    if (
      (selectedToken.name === "XBR" && selectedToken2.name === "USDT") ||
      (selectedToken.name === "USDT" && selectedToken2.name === "XBR")
    ) {
      window.open(
        "https://dexscreener.com/polygon/0x1eb8dfe76ee03fd68aa58f849cad5590b4d12617",
        "_blank"
      );
    } else if (
      (selectedToken.name === "TBA" && selectedToken2.name === "USDT") ||
      (selectedToken.name === "USDT" && selectedToken2.name === "TBA")
    ) {
      window.open(
        "https://dexscreener.com/polygon/0x58f4112b2f44185d2613313bf2f0c6736a2717a6",
        "_blank"
      );
    } else {
      window.open(
        "https://dexscreener.com/polygon/0xd6a31b81199f0281be70caf02af7a9a04522b48f",
        "_blank"
      );
    }
  };
  return (
    <div className="relative w-full rounded-3xl md:bg-white dark:bg-darkCardBg md:shadow-smallShadow pt-6 pb-8">
      {/* Gradient Background for Light Mode */}

      {/* Content */}
      <SectionHeader
        isLatestTrades={true}
        sectionTitle={"Latest Trades"}
        sectionDescription={
          "Dive deeper. Explore the full market for comprehensive insights."
        }
      />

      <div className="w-full overflow-x-auto hide-scrollbar md:border-b md:border-lightGrayBlue dark:border-darkSlateBlue px-6 md:px-8 pt-3 pb-4">
        <TradesTable
          activeTab={activeTab}
          connectedWalletAddress={connectedAccount}
          selectedToken={selectedToken}
          selectedToken2={selectedToken2}
          swapConfirmModal={swapConfirmModal}
        />
      </div>

      <footer className="w-full pt-6 px-6 md:px-8">
        <button
          type={"button"}
          onClick={handleClick}
          className={
            "w-full h-14 flex text-base justify-center items-center rounded-lg gap-2 text-black   font-medium leading-6 py-4 border border-deepBlue bg-white shadow-maxButtonShadow dark:text-white hover:bg-[#F0F4FF] active:bg-[#D8E2FF]  dark:hover:bg-[#3C3A66] dark:bg-transparent"
          }
        >
          Full Market Details
          <ArrowInsertSvg />
        </button>
      </footer>
    </div>
  );
};

export default LatestTrades;
